import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const c = t((e, r) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: r,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "#2D2926",
            d: "m30.025 13.986 8.92 24.868H21.397zm24.311 41.386L34.158 0h-3.84L11.724 52.366c-1.878 5.26-3.284 7.223-7.793 7.223H3V64h21.208v-4.411h-.849c-4.69 0-6.944-.752-6.944-4.133 0-1.128.376-3.382 1.03-5.163l2.533-6.666h20.359l3.66 10.799c.473 1.308.654 2.338.654 3.103 0 2.157-2.157 1.976-7.793 2.06V64h24.395v-4.411c-4.579-.084-5.511-.376-6.917-4.217"
          }
        )
      }
    )
  }
));
c.displayName = "AgencyLogoStickerInverseIcon";
export {
  c as AgencyLogoStickerInverseIcon,
  c as default
};
//# sourceMappingURL=index.js.map
